import { render } from "./ContragentDetail.vue?vue&type=template&id=40e22609"
import script from "./ContragentDetail.vue?vue&type=script&lang=js"
export * from "./ContragentDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__